<div class="d-flex flex-fill flex-column p-2">
  @if (isAdmin) {
    <div class="btn-toolbar mx-0 mt-0 nomination-toolbar">
      <div class="d-flex flex-fill">
        <button class="btn btn-primary" (click)="createVotes()">Create Nomination Votes</button>
        <button class="ms-2 btn btn-primary" (click)="emailVotes()">Email Nomination Votes</button>
        @if (isAdmin) {
          <button class="ms-2 btn btn-primary nomination-assignment-toolbar" (click)="printNominationFormReport()">Print Nomination Form</button>
        }
        @if (isAdmin) {
          <button class="ms-2 btn btn-primary nomination-assignment-toolbar" (click)="settings()">Settings</button>
        }
        @if (isAdmin) {
          <button class="ms-2 btn btn-primary nomination-assignment-toolbar" (click)="nominationInfo()">Info</button>
        }
        <button class="ms-auto btn btn-danger" (click)="closeAll()">Close All Nominations</button>
      </div>
    </div>
  }

  @if (nominations && people) {
    <div class="d-flex flex-fill nomination-display">

      <!-- Panel 1: Nomination Entry -->
      <div class="nom-col border-end" [class.nom-col--open]="showEntryPanel">
        <div class="nom-col__header" (click)="showEntryPanel = !showEntryPanel">
          <span>Nomination Entry</span>
          <span class="fa ms-2" [class.fa-chevron-down]="showEntryPanel" [class.fa-chevron-right]="!showEntryPanel"></span>
        </div>
        @if (showEntryPanel) {
          <div class="nom-col__body d-flex flex-column p-2">
            <div class="d-flex flex-fill flex-column">
              @if (isAdmin) {
                <div style="max-width: 300px">
                  <dx-form class="mb-3" [formData]="nomination" validationGroup="statusChangeData" [colCount]="2">
                    <dxi-item
                      #personSelect
                      dataField="personId"
                      [colSpan]="2"
                      [label]="{ text: 'Person' }"
                      editorType="dxSelectBox"
                      [editorOptions]="{ items: people, valueExpr: 'id', displayExpr: 'displayName', searchEnabled: true, searchMode: 'contains' }"
                    ></dxi-item>
                    <dxi-item
                      dataField="role"
                      [colSpan]="2"
                      [label]="{ text: 'Role' }"
                      editorType="dxSelectBox"
                      [editorOptions]="{ items: roles, searchEnabled: true, searchMode: 'startswith' }"
                    ></dxi-item>
                  </dx-form>
                </div>
              }
              <dx-data-grid
                #nominationGrid
                keyExpr="id"
                class="nominations-grids flex-fill"
                [dataSource]="nominations"
                [columnAutoWidth]="false"
                (onToolbarPreparing)="onToolbarPreparing($event)"
                (onSelectionChanged)="onSelectionChange($event)"
                [focusedRowEnabled]="false"
                [showBorders]="true"
                [height]="700"
                >
                <dxi-column dataField="person.displayName" caption="Name" width="175"></dxi-column>
                <dxi-column dataField="role" caption="Role" width="150"></dxi-column>
                <dxi-column dataField="id" caption="Entered" width="100" [sortIndex]="1" [sortOrder]="'desc'"></dxi-column>
                <div *dxTemplate="let data of 'toolbarButtons'">
                  @if (isAdmin) {
                    <button class="btn btn-primary" (click)="add()" [disabled]="addProcessing || !nomination.personId">Add Nomination</button>
                  }
                  @if (isAdmin) {
                    <button
                      class="btn btn-sm btn-danger ms-4"
                      (click)="deleteNomination()"
                      [disabled]="nominationGrid.instance.getSelectedRowsData().length !== 1"
                      >
                      Delete
                    </button>
                  }
                </div>
                <div *dxTemplate="let data of 'toolbarText'">
                  @if (nominations) {
                    <span class="me-3"
                      ><strong>{{ nominationGrid.instance.totalCount() + " items" }}</strong></span
                      >
                    }
                </div>
                <dxo-export [enabled]="auth.currentUser?.userName === 'mreimink'"></dxo-export>
                <dxo-selection [mode]="'multiple'"></dxo-selection>
              </dx-data-grid>
            </div>
          </div>
        }
      </div>

      <!-- Panel 2: Nomination Grouping -->
      <div class="nom-col border-end" [class.nom-col--open]="showGroupingPanel">
        <div class="nom-col__header" (click)="showGroupingPanel = !showGroupingPanel">
          <span>Nomination Grouping</span>
          <span class="fa ms-2" [class.fa-chevron-down]="showGroupingPanel" [class.fa-chevron-right]="!showGroupingPanel"></span>
        </div>
        @if (showGroupingPanel) {
          <div class="nom-col__body d-flex flex-column p-2">
            <div class="d-flex flex-fill flex-column">
              <div>
                <dx-form class="mb-3" [formData]="assignment" validationGroup="statusChangeData" [colCount]="2">
                  @if (isAdmin) {
                    <dxi-item
                      dataField="role"
                      [colSpan]="1"
                      [label]="{ text: 'Role' }"
                      editorType="dxSelectBox"
                      [editorOptions]="{ items: roles, searchEnabled: true, searchMode: 'startswith' }"
                    ></dxi-item>
                  }
                  <dxi-item>
                    <div *dxTemplate>
                      <dx-check-box text="Show Joined" [(value)]="showJoinedDate"></dx-check-box>
                    </div>
                  </dxi-item>
                </dx-form>
              </div>
              <dx-data-grid
                #groupGrid
                keyExpr="id"
                class="nominations-grids flex-fill"
                [dataSource]="nominationGroups"
                [columnAutoWidth]="false"
                (onToolbarPreparing)="onToolbarPreparing($event)"
                (onSelectionChanged)="onSelectionChange($event)"
                (onRowPrepared)="onRowPrepare($event)"
                [focusedRowEnabled]="false"
                [showBorders]="true"
                [height]="750"
                >
                <dxi-column dataField="name" caption="Name" width="175"></dxi-column>
                <dxi-column dataField="deacon" width="80"></dxi-column>
                <dxi-column dataField="shepherding" width="100"></dxi-column>
                <dxi-column dataField="executive" width="80"></dxi-column>
                <dxi-column dataField="joined" [visible]="showJoinedDate" [format]="'shortDate'" width="100"></dxi-column>
                <dxi-column width="80"></dxi-column>
                <div *dxTemplate="let data of 'toolbarButtons'">
                  @if (isAdmin) {
                    <button class="btn btn-primary" (click)="getGroupedData()">Refresh</button>
                  }
                  @if (isAdmin) {
                    <button class="ms-2 btn btn-danger" (click)="confirm()" [disabled]="!assignment.role">Assign</button>
                  }
                </div>
                <div *dxTemplate="let data of 'toolbarText'">
                  @if (nominationGroups) {
                    <span class="me-3"
                      ><strong>{{ groupGrid.instance.totalCount() + " items" }}</strong></span
                      >
                    }
                </div>
                <dxo-export [enabled]="isAdmin"></dxo-export>
                <dxo-selection [mode]="'multiple'" [showCheckBoxesMode]="'onClick'"></dxo-selection>
              </dx-data-grid>
            </div>
          </div>
        }
      </div>

      <!-- Panel 3: Nomination Assignments -->
      <div class="nom-col" [class.nom-col--open]="showAssignmentsPanel">
        <div class="nom-col__header" (click)="showAssignmentsPanel = !showAssignmentsPanel">
          <span>Nomination Assignments</span>
          <span class="fa ms-2" [class.fa-chevron-down]="showAssignmentsPanel" [class.fa-chevron-right]="!showAssignmentsPanel"></span>
        </div>
        @if (showAssignmentsPanel) {
          <div class="nom-col__body d-flex flex-column p-2">
            <div class="d-flex flex-fill flex-column">
              <div style="max-width: 300px">
                <dx-form class="mb-3" [formData]="assignment" validationGroup="statusChangeData" [colCount]="2"> </dx-form>
              </div>
              <dx-data-grid
                #assignmentGrid
                keyExpr="id"
                class="nominations-grids flex-fill"
                [dataSource]="assignments"
                [columnAutoWidth]="false"
                (onToolbarPreparing)="onToolbarPreparing($event)"
                (onSelectionChanged)="onSelectionChange($event)"
                [focusedRowEnabled]="false"
                [showBorders]="true"
                [height]="800"
                >
                <dxi-column dataField="person.displayName" caption="Name" width="175" cellTemplate="colorTemplate"></dxi-column>
                <dxi-column dataField="role" width="150" cellTemplate="colorTemplate"></dxi-column>
                <dxi-column dataField="status" width="150" cellTemplate="colorTemplate"></dxi-column>
                <dxi-column dataField="note" width="150" cellTemplate="colorTemplate"></dxi-column>
                <dxi-column width="100"></dxi-column>
                <div *dxTemplate="let data of 'toolbarButtons'">
                  @if (isAdmin) {
                    <button class="btn btn-primary nomination-assignment-toolbar" (click)="printNominationForm()">Print Letters</button>
                  }
                  @if (isAdmin) {
                    <button class="btn btn-primary nomination-assignment-toolbar" (click)="printVoteReport()">Print Ballot</button>
                  }
                  @if (isAdmin) {
                    <button
                      class="ms-2 btn btn-danger nomination-assignment-toolbar"
                      (click)="markAssignment('Delete')"
                      [disabled]="assignmentGrid.instance.getSelectedRowsData().length === 0"
                      >
                      Remove
                    </button>
                  }
                  @if (isAdmin) {
                    <button
                      class="ms-3 btn btn-sm btn-primary"
                      (click)="markAssignment('Accept')"
                      [disabled]="assignmentGrid.instance.getSelectedRowsData().length === 0"
                      >
                      Accepted
                    </button>
                  }
                  @if (isAdmin) {
                    <button
                      class="ms-2 btn btn-sm btn-danger"
                      (click)="markAssignment('Decline')"
                      [disabled]="assignmentGrid.instance.getSelectedRowsData().length === 0"
                      >
                      Declined
                    </button>
                  }
                  @if (isAdmin) {
                    <button
                      class="ms-2 btn btn-sm btn-warning"
                      (click)="markAssignment('Clear')"
                      [disabled]="assignmentGrid.instance.getSelectedRowsData().length === 0"
                      >
                      Clear
                    </button>
                  }
                </div>
                <div *dxTemplate="let data of 'toolbarText'">
                  @if (assignments) {
                    <span class="me-3"
                      ><strong>{{ assignmentGrid.instance.totalCount() + " items" }}</strong></span
                      >
                    }
                </div>
                <div *dxTemplate="let cell of 'colorTemplate'">
                  <div class="{{ cell.data.accepted ? 'accepted' : cell.data.declined ? 'declined' : '' }}">
                    {{ cell.text }}
                  </div>
                </div>
                <dxo-export [enabled]="isAdmin"></dxo-export>
                <dxo-filter-row [visible]="true"></dxo-filter-row>
                <dxo-selection [mode]="'multiple'" [showCheckBoxesMode]="'onClick'"></dxo-selection>
              </dx-data-grid>
            </div>
          </div>
        }
      </div>

    </div>
  }
</div>
